import { combineReducers } from 'redux'
import loadingReducer from './loading.reducer'
import notifyReducer from './notify.reducer'
import alertReducer from './alert.reducer'
import authReducer from './auth.reducer'
import usuariosReducer from './usuarios.reducer'
import campaignsReducer from './campaigns.reducer'
import cotasReducer from './cotas.reducer'
import rouletteReducer from './roulette.reducer'
import linksReducer from './links.reducer'
import topReducer from './top.reducer'
import navigationReducer from './navigation.reducer'
import appReducer from './app.reducer'
import accountReducer from './account.reducer'
import mercadopagoReducer from './mercadopago.reducer'
import metricsReducer from './metrics.reducer'
import cuponsReducer from './cupons.reducer'
import menorReducer from './menor.reducer'
import menorGestaoReducer from './menor.gestao.reducer'
import transactionReducer from './transaction.reducer'
import shoppingReducer from './shopping.reducer'
import pixelReducer from './pixel.reducer'
import googleReducer from './google.reducer'
import webhookReducer from './webhooks.reducer'
import smsReducer from './sms.reducer'
import afiliadosReducer from './afiliados.reducer'
import gestorReducer from './gestor.reducer'
import notificationReducer from './notification.reducer'
import prizesReducer from './prizes.reducer'
import reportsWhatsappReducer from './reports.whatsapp.reducer'

const rootReducer = combineReducers({
    loadingReducer,
    notifyReducer,
    alertReducer,
    authReducer,
    usuariosReducer,
    campaignsReducer,
    cotasReducer,
    rouletteReducer,
    metricsReducer,
    navigationReducer,
    appReducer,
    accountReducer,
    mercadopagoReducer,
    cuponsReducer,
    menorReducer,
    menorGestaoReducer,
    transactionReducer,
    linksReducer,
    topReducer,
    shoppingReducer,
    pixelReducer,
    googleReducer,
    webhookReducer,
    smsReducer,
    afiliadosReducer,
    gestorReducer,
    notificationReducer,
    prizesReducer,
    reportsWhatsappReducer
})

export default rootReducer;